import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'epargn_details.title',
  },
  releve_situation_title: {
    id: 'releve_situation.title',
  },
});
